export default __webpack_public_path__ + "static/media/linkedin-icon.211e926e.svg";